// src/pages/User/NewRequest/ui/steps/review/ReviewStepDesktop.tsx
import React from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

import { PreviewField } from "../../components/PreviewField";
import { useReviewStep } from "../../hook/useReviewStep";
import { formatQty } from "../../hook/useProductsStep";
import { cardOutlinedSx } from "../purchase/styles";

export function ReviewStepDesktop() {
  const { state, action } = useReviewStep();

  return (
    <Card variant="outlined" sx={cardOutlinedSx}>
      <CardContent>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
          Total
        </Typography>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          <PreviewField
            label="Quantidade total do pedido (L)"
            value={`${formatQty(state.totals.totalQuantity)} litros`}
          />

          <PreviewField
            label="Preço total do pedido"
            value={state.formattedTotalPrice}
          />

          <Stack direction="row" spacing={2}>
            <Button
              color="error"
              variant="text"
              onClick={action.reset}
              sx={{
                border: "1px solid transparent",
                "&:hover": {
                  borderColor: "error.main",
                  backgroundColor: (theme) =>
                    alpha(theme.palette.error.main, 0.04),
                },
              }}
            >
              Cancelar
            </Button>

            <Button
              type="submit"
              variant="contained"
              disabled={!state.canSubmit}
            >
              {state.isSubmitting ? "Enviando..." : "Finalizar"}
            </Button>
          </Stack>
        </Box>

        {!state.validation.ok ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              maxWidth: 350,
              ml: "auto",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                opacity: 0.75,
                color: "primary.main",
                textAlign: "justify",
              }}
            >
              {state.validation.reason}
            </Typography>
          </Box>
        ) : null}
      </CardContent>
    </Card>
  );
}
